import { BottomNav, type BottomNavItem } from './BottomNav';
import { Sidebar, type SidebarNavGroup } from './Sidebar';
import { chromeTokens, type Surface } from './surface';
import { TopBar } from './TopBar';

import type { ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

interface AppShellProps {
  pageTitle: string;
  sidebarGroups: SidebarNavGroup[];
  bottomNavItems: BottomNavItem[];
  homeHref: string;
  sidebarAccentClass?: string;
  /** The tool-exit "Home" affordance (Spec 28 A4); omit on the reader shell. */
  exitLink?: { to: string; label: string };
  surface?: Surface;
  children: ReactNode;
}

export function AppShell({
  pageTitle,
  sidebarGroups,
  bottomNavItems,
  homeHref,
  sidebarAccentClass,
  exitLink,
  surface = 'editorial',
  children,
}: AppShellProps) {
  return (
    <div className="flex min-h-screen">
      <Sidebar
        groups={sidebarGroups}
        homeHref={homeHref}
        accentClass={sidebarAccentClass}
        surface={surface}
        exitLink={exitLink}
      />
      <div className="flex min-h-screen flex-1 flex-col">
        <TopBar title={pageTitle} surface={surface} />
        <main
          className={cn(
            'flex-1 px-4 pb-24 pt-6 transition-colors md:px-8 md:pb-10',
            chromeTokens[surface].shellMain,
          )}
        >
          {children}
        </main>
      </div>
      <BottomNav items={bottomNavItems} homeHref={homeHref} />
    </div>
  );
}
